var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-data-table", {
        attrs: {
          classTable: _vm.classTable,
          "table-columns": _vm.columns,
          "table-rows": _vm.rows,
          "is-loading": _vm.isLoading,
          stickyTable: true,
          "empty-rows-message": _vm.$t("components.table.no_data"),
        },
        on: _vm._d({}, [_vm.needDataUpdateEvent, _vm.init]),
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function (props) {
              return [
                props.cell.getColumn.id == "employee.holidaysRemaining"
                  ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                  : props.cell.getColumn.id == "employee.hourBalance"
                  ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                  : props.cell.getColumn.id == "plan.workShiftDescription"
                  ? [
                      _c("workshift-legend", {
                        attrs: {
                          date: props.cell.getRaw.plan.date,
                          workShiftCode: props.cell.getRaw.plan.workShiftCode,
                          workShiftDescription:
                            props.cell.getRaw.plan.workShiftDescription,
                        },
                      }),
                    ]
                  : props.cell.getColumn.id == "employee.fullName"
                  ? [
                      _c("div", [
                        _vm._v(" " + _vm._s(props.cell.getValue) + " "),
                      ]),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "badge badge-pill badge-light pl-0" },
                          [
                            _vm._v(
                              _vm._s(props.cell.getRaw.employee.employeeCode) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : !["actions"].includes(props.cell.getColumn.id)
                  ? [
                      _c("plan-day-item-table-component", {
                        attrs: { cellData: props.cell },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "table-action-menu",
            fn: function (props) {
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "planing-team-validate",
                        params: { code: props.row.raw.employee.employeeCode },
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("pages.permission.validate_hours")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "profile-employee",
                        params: { code: props.row.raw.employee.employeeCode },
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.profile.tabs.personal_data.title")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "description",
            fn: function () {
              return [
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("hour-planned-legend", {
                        staticClass: "m-1",
                        staticStyle: { width: "170px" },
                        attrs: { rounded: true },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("absence-justified-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("absence-unjustified-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("absence-confirm-waiting-day-legend", {
                        staticClass: "m-1",
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("vacations-approved-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacation-confirm-waiting-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacations-need-meeting-day-legend", {
                        staticClass: "m-1",
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("off-day-legend", { staticClass: "m-1" }),
                      _c("sick-day-legend", { staticClass: "m-1" }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }